import {
	type RequirementFlagListForResidenceData,
	requirementFlagGetForResidence,
	requirementFlagListForResidence
} from '@repo/sdk/gen'
import { queryOptions } from '@tanstack/react-query'
import { makeQueryKeys } from '@/query/query-keys'

// The flags name the students they are about: every fetch is recorded in the
// event log as an access (decision D37). They keep the client defaults, as the
// applications do: one opening of a page is one access, not one per focus.

/** The flags of the valid applications of a residence of the manager. */
export function flagsListQueryOptions(
	body: RequirementFlagListForResidenceData['body']
) {
	return queryOptions({
		queryKey: makeQueryKeys.flags.index(body.filters.residenceId, body),
		queryFn: ({ signal }) =>
			requirementFlagListForResidence({ body, signal }),
		// Another residence's rows never stay on screen: they are other students.
		placeholderData: (previous, previousQuery) =>
			previousQuery?.queryKey[2] === body.filters.residenceId
				? previous
				: undefined
	})
}

/** One flag with the files of its application. */
export function flagDetailQueryOptions(residenceId: string, flagId: string) {
	return queryOptions({
		queryKey: makeQueryKeys.flags.detail(residenceId, flagId),
		queryFn: async ({ signal }) =>
			(
				await requirementFlagGetForResidence({
					body: { data: { residenceId, flagId } },
					signal
				})
			).data
	})
}
